import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { CustomDropDown } from '../models/custom-dropdown.model';

const DROP_OPTION_SECTION = 'dropOptionSection';
const SHOW = 'show';

@Component({
  selector: 'custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss']
})
export class CustomDropdownComponent implements OnInit {
  @Input() selectText!: string;
  @Input() options!: CustomDropDown[];
  @Input() isDisabled!: boolean;
  @Input() inputTooltip!: string;
  @Input() buttonHeight!: boolean;
  @Output() optionSelectedEvent = new EventEmitter<CustomDropDown>();
  dropdownSelectElement: HTMLDivElement;
  showError = false;
  

  constructor(@Inject(DOCUMENT) private _document: Document) { }

  ngOnInit(): void {
    this.dropdownSelectElement = this._document.getElementById(DROP_OPTION_SECTION) as HTMLDivElement;
  }

  toggleOnSelect(): void {
    if (this.dropdownSelectElement && this.dropdownSelectElement.classList) {
      this.dropdownSelectElement.classList.toggle(SHOW);
    }
  }

  selectOption(optionSelected: CustomDropDown): void {
    if (optionSelected) {
      this.toggleOnSelect();
      this.selectText = optionSelected.value;
      this.optionSelectedEvent.emit(optionSelected);
    }
  }

  closeDropdown(): void {
    if (this.dropdownSelectElement && this.dropdownSelectElement.classList && this.dropdownSelectElement.classList.contains(SHOW)) {
      this.dropdownSelectElement.classList.remove(SHOW);
      this.optionSelectedEvent.emit(null);
    }
  }
}
